import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '../firebase';
import {
  applyLockoutSettingsFromRemote,
  DEFAULT_LOCKOUT_SETTINGS
} from '../utils/checkLockout';

/** Firestore: AppMaintenance/status — fields: locked (bool), message (string) */
export const appMaintenanceStatusRef = doc(
  firestore,
  'AppMaintenance',
  'status'
);

/**
 * Live status for optional full-app maintenance mode + lockout tuning.
 * Firestore document: AppMaintenance/status
 * - locked (boolean), message (string): full-app WIP screen
 * - podLockEditDays (number): POD date lockback for non-admins
 * - timeLockoutWeekday (0–6), timeLockoutHour (0–23): weekly time-edit boundary
 * - managerTimeLockoutWeekday, managerTimeLockoutHour: stricter boundary for manager non-admins
 */
const useAppMaintenance = () => {
  const [state, setState] = useState({
    locked: false,
    message: '',
    loaded: false,
    ...DEFAULT_LOCKOUT_SETTINGS
  });

  useEffect(() => {
    const unsub = onSnapshot(
      appMaintenanceStatusRef,
      (snap) => {
        if (!snap.exists()) {
          const lockout = applyLockoutSettingsFromRemote(null);
          setState({
            locked: false,
            message: '',
            loaded: true,
            ...lockout
          });
          return;
        }
        const d = snap.data() || {};
        const lockout = applyLockoutSettingsFromRemote(d);
        setState({
          locked: Boolean(d.locked),
          message: typeof d.message === 'string' ? d.message : '',
          loaded: true,
          ...lockout
        });
      },
      () => {
        const lockout = applyLockoutSettingsFromRemote(null);
        setState({
          locked: false,
          message: '',
          loaded: true,
          ...lockout
        });
      }
    );
    return unsub;
  }, []);

  return state;
};

export default useAppMaintenance;
